import type { MiningAllocationPolicy } from "../mining-engine/server-lease";

/** FE request ceiling, not a claim about the deployed BE cap or PoW difficulty. */
export function miningAllocationPolicy(): MiningAllocationPolicy {
  return Object.freeze({ allocationSize: 100_000_000 });
}
